<template>
  <Grid v-if="features.length" :columns="3" style="margin-top: 3rem">
    <h3>Kollektivtransport</h3>
    <Features class="location-features" :value="features" :columns="2" style="grid-column: span 2" />
  </Grid>
</template>

<script>
import Features from './Features.vue'
import Grid from './Grid'

const iconMap = {
  bus: ['far', 'bus'],
  train: ['far', 'train'],
  subway: ['far', 'train-subway-tunnel'],
  tram: ['far', 'train-tram'],
  parkingSpots: ['far', 'square-parking'],
}

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    features() {
      return (this.value || [])
        .filter(f => f && (f.title || f.subtitle))
        .map(f => ({
          title: (f.title || '').trim(),
          subtitle: (f.subtitle || '').trim(),
          icon: f.icon,
          preselectedIcon: iconMap[f['preselected-icon']],
        }))
    },
  },
  components: {
    Features,
    Grid,
  },
}
</script>
